import { axios as requestInstance } from '../../../api/axios-instance';

import { AccessApi } from './AccessApi';

export const accessApi = new AccessApi(requestInstance);

export * from './AccessApi';
